import { render, staticRenderFns } from "./LiveCalendar.vue?vue&type=template&id=3ee48640&scoped=true"
import script from "./LiveCalendar.vue?vue&type=script&lang=js"
export * from "./LiveCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee48640",
  null
  
)

export default component.exports